<template>
    <b-table hover small responsive show-empty class="sr-caption"
             aria-live="polite"
             :id="slug"
             :fields="fields"
             :items="items"
             primary-key="id"
             :busy="isLoading"
             label-sort-asc=""
             label-sort-desc=""
             :sort-by="'lastName'"
             :sort-desc="false"
    >
        <template v-slot:cell(endDate)="row">
            {{formatDate(row.item.endDate)}}
        </template>
        <template v-slot:empty="scope">
            <p>No CNAs listed.</p>
        </template>
        <template v-slot:cell(lastWorkedDate)="row">
            <div>{{formatDate(row.item.lastWorkedDate)}}</div>
        </template>
        <template v-slot:cell(certExpirationDate)="row">
          <div>{{formatDate(row.item.certExpirationDate)}}</div>
        </template>
        <template v-slot:cell(status)="row">
            <div v-if="row.item.status.code==='OTH'">
                {{row.item.status.description}}: {{row.item.otherStatus}}
            </div>
            <div v-else>
                {{row.item.status.description}}
            </div>
        </template>
        <template v-slot:cell(actions)="row">
            <div v-if="row.item.verified.code==='VERIFIED'">
                <b-button variant="primary" @click="showStatusModal(row.item)">Change Status</b-button>
            </div>
            <div v-if="row.item.verified.code==='PENDING'">
                <b-button variant="primary" @click="showVerifyModal(row.item)">Verification</b-button>
            </div>
        </template>
        <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"
                       label="Loading, Please Wait" aria-label="Loading, Please Wait"></b-spinner>
            <strong>Loading, Please Wait...</strong>
        </div>
    </b-table>
</template>

<script>
    import axios from 'axios';
    import moment from 'moment';

    export default {
        name: "ProviderCNAList",
        components:{},
        props:{
            items: Array,
            slug:[String],
            isLoading: Boolean,
        },
        data:()=>({
            fields:[
                {key: 'lastName', label:'Last Name',sortable: true},
                {key: 'firstName',label:'First Name',sortable:true},
                {key: 'ssn4', label: 'SSN', sortable: true},
                {key: 'status',label: 'Status', sortable: true},
                {key: 'lastWorkedDate',label:'Last Worked Date',sortable: true},
                {key: 'certExpirationDate',label:'Certificate expiration date', sortable: true},
                {key: 'actions',label: 'Actions'}
            ],
            startDateMessages: {
                minDate: 'Start Date must be after 01/01/1900.',
                maxDate: 'Start Date cannot be in the future.'
            },
            endDateMessages: {
                minDate: 'End Date must be after Start Date.',
                maxDate: 'End Date can not be in the future.'
            },
            currentItem: null,
        }),
        methods:{
            formatDate(unformattedDate){
                let formattedDate = moment(unformattedDate);
                if(!formattedDate.isValid()) return 'N/A';
                return formattedDate.format("MM/DD/YYYY");
            },
            showStatusModal(item){
                this.$emit('showStatusModal',item);
            },
            showVerifyModal(item){
                this.$emit('showVerifyModal',item);
            }
        }
    }
</script>

<style scoped>

</style>

